import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { isNil } from 'lodash'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import FlexColumn from '../../shared/components/layouts/FlexColumn'
import Flex from '../../shared/components/layouts/Flex'
import TwoFactorSetupDialog from './TwoFactorSetupDialog'
import TwoFactorDeactivateDialog from './TwoFactorDeactivateDialog'

const TwoFactorSection = ({ otpEnabled, onStatusChange }) => {
  const [setupOpen, setSetupOpen] = useState(false)
  const [deactivateOpen, setDeactivateOpen] = useState(false)

  const handleActivated = () => {
    setSetupOpen(false)
    onStatusChange()
  }

  const handleDeactivated = () => {
    setDeactivateOpen(false)
    onStatusChange()
  }

  return (
    <FlexColumn gap={2}>
      <Flex alignItems="center" gap={2}>
        {otpEnabled === true && (
          <Chip
            label={<FormattedMessage id="settings.twoFactor.status.enabled" />}
            color="success"
            size="small"
          />
        )}
        {otpEnabled === false && (
          <Chip
            label={<FormattedMessage id="settings.twoFactor.status.disabled" />}
            color="default"
            size="small"
          />
        )}
        {isNil(otpEnabled) && (
          <Chip
            label={<FormattedMessage id="settings.twoFactor.status.neverConfigured" />}
            color="default"
            size="small"
          />
        )}
      </Flex>

      {otpEnabled === true ? (
        <Flex>
          <Button
            variant="outlined"
            color="error"
            onClick={() => setDeactivateOpen(true)}
          >
            <FormattedMessage id="settings.twoFactor.disable" />
          </Button>
        </Flex>
      ) : (
        <Flex>
          <Button
            variant="contained"
            onClick={() => setSetupOpen(true)}
          >
            <FormattedMessage id="settings.twoFactor.enable" />
          </Button>
        </Flex>
      )}

      <TwoFactorSetupDialog
        open={setupOpen}
        onClose={() => setSetupOpen(false)}
        onActivated={handleActivated}
      />

      <TwoFactorDeactivateDialog
        open={deactivateOpen}
        onClose={() => setDeactivateOpen(false)}
        onDeactivated={handleDeactivated}
      />
    </FlexColumn>
  )
}

export default TwoFactorSection
